import { Controller } from "stimulus"
import { finalizeForm, removeFieldErrorState } from "validators/validation_display"

// generic value used to mark a field as invalid (used in setCustomValidity)
// see app/javascript/validators/validation_display.js for more details
const INVALID_MARK = 'invalid'

export default class extends Controller {
  static targets = ["Check", "SubmitButton", "FirstNameField", "LastNameField", "FirstName", "LastName"]

  get isAccessibleValidationEnabled() {
    return document.documentElement.dataset.accessibleFormValidation === 'true'
  }

  connect() {
    if (this.isAccessibleValidationEnabled) {
      this.SubmitButtonTarget.disabled = false
      this.SubmitButtonTarget.classList.remove('disabled')
    } else {
      this.canSubmitCheck()
    }
  }

  canSubmitCheck() {
    if (this.isAccessibleValidationEnabled) {
      this.CheckTargets.forEach(check => removeFieldErrorState(check))
      return
    }

    let allChecked = this.CheckTargets.every(check => check.checked)
    let validSignature = this.checkSignature()
    let canSubmit = allChecked && validSignature
    if (canSubmit) {
      this.SubmitButtonTarget.disabled = false
      this.SubmitButtonTarget.classList.remove('disabled')
    } else {
      this.SubmitButtonTarget.disabled = true
      this.SubmitButtonTarget.classList.add('disabled')
    }
  }

  clearSignatureErrors() {
    if (!this.isAccessibleValidationEnabled) return
    removeFieldErrorState(this.FirstNameFieldTarget)
    removeFieldErrorState(this.LastNameFieldTarget)
  }

  // runs on keyup/change of the signature fields and on submit to validate signature/checkboxes
  validateSubmission(event) {
    if (!this.isAccessibleValidationEnabled) return

    this.CheckTargets.forEach(check => check.setCustomValidity(check.checked ? '' : INVALID_MARK))

    const firstName = this.FirstNameTarget.value
    const lastName = this.LastNameTarget.value
    const firstNameValid = this.FirstNameFieldTarget.value.toLowerCase() === firstName && firstName.length > 0
    const lastNameValid = this.LastNameFieldTarget.value.toLowerCase() === lastName && lastName.length > 0
    this.FirstNameFieldTarget.setCustomValidity(firstNameValid ? '' : INVALID_MARK)
    this.LastNameFieldTarget.setCustomValidity(lastNameValid ? '' : INVALID_MARK)

    if (!finalizeForm(this.element.querySelector('form'))) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  checkSignature() {
    let firstNameInput = this.FirstNameFieldTarget.value
    let lastNameInput = this.LastNameFieldTarget.value
    let firstName = this.FirstNameTarget.value
    let lastName = this.LastNameTarget.value
    if (firstNameInput.length > 0 && lastNameInput.length > 0 && firstName.length > 0 && lastName.length > 0) {
      return firstNameInput.toLowerCase() === firstName && lastNameInput.toLowerCase() === lastName
    } else {
      return false
    }
  }

}